/**
 * © Moustapha HENNAWI - Click and Take off - 2021
 */

/*-------------------------------------------------------------------------------------------*/

import { createSlice } from '@reduxjs/toolkit';

/*-------------------------------------------------------------------------------------------*/

const { reducer, actions } = createSlice({
  name: 'groups',
  initialState: {
    items: [],
    clubLatLong: [2.33333, 48.86666],
    token: [],
    selectedId: -1
  },
  reducers: {
    update(state, action) {
      action.payload.forEach((item) => (state.items[item.id] = item));
    },

    updateClubLatLong(state, action) {
      state.clubLatLong = action.payload;
    },

    updateToken(state, action) {
      action.payload.forEach((item) => (state.token[item.id] = item));
    },

    delete(state, action) {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },

    deleteToken(state, action) {
      state.token = state.token.filter((item) => item.id !== action.payload);
    },

    select(state, action) {
      state.selectedId = action.payload;
    }
  }
});

/*-------------------------------------------------------------------------------------------*/

export { actions as groupsActions };
export { reducer as groupsReducer };

/*-------------------------------------------------------------------------------------------*/
